import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import HeadingSection from 'components/LandingPageHeadingSection/HeadingSection';
import Styles from './styles.js';

const FeaturesSliderUptoFive = ({ bg, heading, imageSource }) => {
  function SampleNextArrow(props) {
    const { onClick } = props;
    return (
      <div className={' slick-arrow right-arrow'} style={{}} onClick={onClick}>
        <svg
          viewBox="0 0 24 24"
          fill="currentColor"
          width="28"
          height="28"
          data-ux="Icon"
          data-edit-interactive="true"
          className="x-el x-el-svg ">
          <path
            fillRule="evenodd"
            d="M7.236 4.195a.773.773 0 0 1
             1.06.031l7.743 7.883-7.742 7.42a.773.773
              0 0 1-1.06 0 .697.697 0 0 1
               0-1.017l6.712-6.433-6.745-6.868a.697.697 0
                0 1 .032-1.016"></path>
        </svg>
      </div>
    );
  }

  function SamplePrevArrow(props) {
    const { onClick } = props;
    return (
      <div className={' slick-arrow left-arrow'} onClick={onClick}>
        <svg
          viewBox="0 0 24 24"
          fill="currentColor"
          width="28"
          height="28"
          data-ux="Icon"
          data-edit-interactive="true"
          className="x-el x-el-svg  ">
          <path
            fillRule="evenodd"
            d="M15.804 19.544a.774.774 0 0 1-1.061-.03L7
             11.63l7.742-7.42a.773.773 0 0 1 1.061 0
              .697.697 0 0 1 0 1.017L9.09 11.66l6.745
               6.867a.698.698 0 0 1-.031 1.016"></path>
        </svg>
      </div>
    );
  }

  var settings = {
    className: 'FeatureSlider FeatureSliderUptoFive',
    dots: false,
    infinite: true,
    slidesToShow: 3,
    speed: 500,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    cssEase: 'scroll',
    nextArrow: <SampleNextArrow className="slick-arrow right-arrow" />,
    prevArrow: <SamplePrevArrow className="slick-arrow left-arrow" />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          dots: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          arrows: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          dots: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          dots: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true,
        },
      },
    ],
  };
  var settingsBlack = {
    className: 'FeatureSliderBlack FeatureSliderUptoFive FeatureSliderUptoFiveBlack',
    dots: false,
    infinite: true,
    slidesToShow: 3,
    speed: 500,
    slidesToScroll: 3,
    arrows: true,
    autoplay: true,
    cssEase: 'scroll',
    nextArrow: <SampleNextArrow className="slick-arrow right-arrow" />,
    prevArrow: <SamplePrevArrow className="slick-arrow left-arrow" />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          dots: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          arrows: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          dots: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          initialSlide: 2,
          arrows: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          dots: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true,
        },
      },
    ],
  };
  return (
    <>
      {bg == 'black' ? (
        <div>
          <HeadingSection title="PRICES ARE INCLUSIVE OF EVERYTHING A SOULROOM COMES WITH" bgcolor="black" />
          <div className="  px-md-3 px-xxl-5 " style={{ backgroundColor: '#161616' }}>
            <div className=" px-md-3 px-xl-0 px-xxl-5 mx-xl-0 mx-xxl-4 ">
              <div className="lg:container px-md-3 px-xl-4 px-xxl-5  pt-4 pb-4">
                <Slider {...settingsBlack}>
                  {imageSource.map((Item, index) => (
                    <div key={index}>
                      <img
                        loading="lazy"
                        className="d-block w-100 px-md-3 px-3 px-lg-4"
                        src={Item.src}
                        alt="First slide"
                      />
                    </div>
                  ))}
                </Slider>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div>
          {heading ? (
            <HeadingSection title={heading} bgcolor="white" />
          ) : (
            <HeadingSection title="PRICES ARE INCLUSIVE OF EVERYTHING A SOULROOM COMES WITH" bgcolor="white" />
          )}
          <div className="  px-md-3 px-xxl-5 ">
            <div className=" px-md-3 px-xl-0 px-xxl-5 mx-xl-0 mx-xxl-4 ">
              <div className="lg:container mx-auto">
                <Slider {...settings}>
                  {imageSource.map((Item, index) => (
                    <div key={index}>
                      <img loading="lazy" className="px-3" src={Item.src} alt="First slide" />
                    </div>
                  ))}
                </Slider>
              </div>
            </div>
          </div>
        </div>
      )}
      <Styles />
    </>
  );
};
export default FeaturesSliderUptoFive;
